import { PageHeader, PageWrapper, ProfileNameClamp } from './profile.styled';
import Heading from '../../../components/typography';
import Tabs from '../../../components/tabs';
import CompanyComponent from './company';
import HeadquarterComponent from './headquarter';
import ContactComponent from './contacts';
import { useGetCompanyProfileDetails, useWealthlaneCustomerApi } from '../../../hooks';
import ProfileUpload from './profileUpload';
import { useState } from 'react';
import Tooltip from '../../../components/tooltip';
import AuthService from '../../../services/authService';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../../auth/authSlice';

const CompanyProfile = (): JSX.Element => {
  const [openTab, setOpenTab] = useState(0);
  const { handleRequest } = useWealthlaneCustomerApi();
  const authService = new AuthService();
  const isAuthenticated = useSelector(selectIsAuthenticated) || authService.isAuthenticated();
  const { data, isLoading } = useGetCompanyProfileDetails(handleRequest, isAuthenticated);

  const items = [
    {
      name: 'Company Information',
      content: <CompanyComponent data={data} loading={isLoading} />,
    },
    {
      name: 'Headquarter Address Details',
      content: <HeadquarterComponent data={data} loading={isLoading} />,
    },
    {
      name: 'Key Contacts',
      content: <ContactComponent data={data} loading={isLoading} handleRequest={handleRequest} />,
    },
  ];

  return (
    <PageWrapper id="companyProfilePageContainer">
      <PageHeader id="companyProfilePageHeader">
        <Heading variant='h3' title='Company Profile' id="companyProfilePageTitle" />
        <Heading variant='body-s' title='Secure your account & manage your password' id="companyProfilePageDescription" />
      </PageHeader>
      <div className='flex flex-col xl:flex-row page' id="companyProfilePageContent">
        <div id="companyProfileLeftSection">
          <ProfileUpload handleRequest={handleRequest} id="companyProfileUpload" />
          <Tooltip tooltipText={data?.companyName} showArrow variant='dark' id="companyProfileNameTooltip">
            <span id="companyProfileNameContainer">
              <ProfileNameClamp variant='h3' title={data?.companyName} fontWeight={600} id="companyProfileName" />
            </span>
          </Tooltip>
        </div>
        <div className='grid profile-info' id="companyProfileRightSection">
          <Tabs
            hasTabContent
            tabIndex={openTab}
            setTabIndex={(index) => {
              setOpenTab(index);
            }}
            items={items}
            id="companyProfileTabs"
          />
        </div>
      </div>
    </PageWrapper>
  );
};

export default CompanyProfile;
